import React from 'react';
import { AssetTransaction } from '../types/asset_transaction/assetTransaction';

export interface AssetTransactionContextProps {
  assetTransactions: Map<string, AssetTransaction>;
  setAssetTransactions: (assetTransaction: Map<string, AssetTransaction>) => void;
  assetTransactionsLoading: boolean;
}

const defaultContext: AssetTransactionContextProps = {
  assetTransactions: new Map(),
  setAssetTransactions: () => {},
  assetTransactionsLoading: false,
};

export const AssetTransactionContext = React.createContext<AssetTransactionContextProps>(defaultContext);
